import { z } from "zod"

const formErrorDict = {
  invalidEmail: "Email must be valid",
  filenameAlreadyExists: (filename) =>
    `The file name ${filename} already exists. Please enter a unique file name to continue.`,
  errorCheckingFilename: "Error checking filename uniqueness.",
  fileOrLinkRequired: "Upload a file or add a file link.",
  fileOrLinkNotBoth: "Upload a file or add a file link, not both.",
}

const emailSchema = z.string().email({ message: formErrorDict.invalidEmail })

// validate array of email address strings
const emailsValidator = () => ({
  validator: (_, value) => {
    if (value && value.length > 0) {
      if (value.some((email) => !emailSchema.safeParse(email).success)) {
        return Promise.reject(new Error(formErrorDict.invalidEmail))
      }
    }
    return Promise.resolve()
  },
})

// pair with linkFileValidator
const fileLinkValidator = ({ getFieldValue }) => ({
  validator: (_, value) => {
    if (!value && !getFieldValue("document_link")) {
      return Promise.reject(new Error(formErrorDict.fileOrLinkRequired))
    }
    if (value && getFieldValue("document_link")) {
      return Promise.reject(new Error(formErrorDict.fileOrLinkNotBoth))
    }
    if (value) {
      return Promise.resolve()
    }
    return Promise.resolve()
  },
})

// pair with fileLinkValidator
const linkFileValidator = ({ getFieldValue }) => ({
  validator: (_, value) => {
    if (!value && !getFieldValue("document_file")) {
      return Promise.reject(new Error(formErrorDict.fileOrLinkRequired))
    }
    if (value && getFieldValue("document_file")) {
      return Promise.reject(new Error(formErrorDict.fileOrLinkNotBoth))
    }
    return Promise.resolve()
  },
})

const validateUniqueFilename = (oldValue = "", newValue, globalDocsSearch) => {
  return new Promise((resolve, reject) => {
    if (oldValue === newValue) {
      return resolve()
    }

    globalDocsSearch(
      {
        body: { filter_val: newValue },
      },
      {
        onSuccess: (res) => {
          if (
            res?.data?.results &&
            res.data.results.length > 0 &&
            res.data.results.some((doc) => doc.name === newValue)
          ) {
            return reject(new Error(formErrorDict.filenameAlreadyExists(newValue)))
          }
          return resolve()
        },
        onError: () => reject(new Error(formErrorDict.errorCheckingFilename)),
      }
    )
  })
}

export { emailsValidator, fileLinkValidator, linkFileValidator, validateUniqueFilename, formErrorDict }
